export default {};

export const useSetInputNumberLanguage = (
  primeConfig: any,
  language: string
) => {};
